import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { State } from '../../../../order/models/localization-state';
import { DatacenterType, UserDatacenterView } from '../../../models/datacenter-aggrid-view';
import { UserService } from '../../../services/user.service';
import { DatacenterViewService } from '../../../services/datacenter-view.service';
import { View, CustomizedViewSetting } from '../../../models/settings';

@Injectable({ providedIn: 'root' })
export class ProductListViewService extends DatacenterViewService {
	private _viewToEditBis: {
		currentView: UserDatacenterView;
		viewType: DatacenterType;
		viewSubType: string;
		viewList: UserDatacenterView[];
	} | undefined;

	constructor(
		readonly _location: Location,
		readonly _http: HttpClient,
		readonly _router: Router,
		readonly _userService: UserService,
	) {
		super(_location, _http, _router, _userService);
	}

	override get viewToEdit() {
		return this._viewToEditBis;
	}

	override set viewToEdit(
		viewToEdit: {
			currentView: UserDatacenterView;
			viewType: DatacenterType;
			viewSubType: string;
			viewList: UserDatacenterView[];
		} | undefined
	) {
		this._viewToEditBis = viewToEdit;
	}

	getViews() {
		const state: State = <State> this._location.getState();
		return state.views ?? [];
	}

	getCurrentViewByKey(defaultView: UserDatacenterView, type: string, key: string, colIds: string[]) {
		let view: UserDatacenterView = defaultView;
		let layoutFromState = false;
		const state: State = <State> this._location.getState();
		if (state.views) {
			for (const viewObj of state.views) {
				if (viewObj.type === type && viewObj.subType === key) {
					view = viewObj;
					layoutFromState = true;
				}
			}
		}
		if (!layoutFromState) {
			const settingsType = this._userService.user.getSettings(key);
			if (settingsType) {
				try {
					const viewSetting = <CustomizedViewSetting> settingsType;
					if (this.isValidLayout(viewSetting.value, colIds)) {
						view = {
							id: defaultView.id,
							name: defaultView.name,
							type: defaultView.type,
							isFavorite: Boolean(defaultView.isFavorite),
							isDefault: defaultView.isDefault,
							...viewSetting.value
						};
					}
				} catch (err) {
					console.error(err);
				}
			}
		}
		const clone: UserDatacenterView = {
			...view,
			columnState: [...view.columnState],
			filterState: view.filterState ? [...view.filterState] : view.filterState,
			sortModel: view.sortModel ? [...view.sortModel] : view.sortModel
		};
		return clone;
	}

	private isValidLayout(view: View, colIds: string[]) {
		if (view.columnState.length === 0) {
			return false;
		}
		for (const column of view.columnState) {
			if (!column.colId || !colIds.includes(column.colId)) {
				return false;
			}
		}
		if (view.sortModel) {
			for (const sortModel of view.sortModel) {
				if (!sortModel.colId || !colIds.includes(sortModel.colId)
					|| !['asc', 'desc'].includes(sortModel.sort)) {
					return false;
				}
			}
		}
		return true;
	}
}
